export default __webpack_public_path__ + "static/media/gmapStatic.3b2cc008.png";